import React from "react";
import { Button, Table } from "react-bootstrap";
import ProcessStatusBadge from "./ProcessStatusBadge";

export default function ProcessQueueTable({
  rows = [],
  onManage,
  onTake,
  onAssign,
  onRelease,
  loading = false,
  includeProcess = false,
  compact = false,
  emptyMessage = "No hay instancias para mostrar.",
  showActions = true,
  className = "",
  containerClassName = "",
}) {
  const columns = compact
    ? [
        includeProcess ? "process" : null,
        "priority",
        "commerce",
        "cuit",
        "status",
        "responsible",
        "nextAction",
        showActions ? "actions" : null,
      ].filter(Boolean)
    : [
        includeProcess ? "process" : null,
        "commerce",
        "cuit",
        "terminal",
        "origin",
        "status",
        "attempt",
        "channel",
        "nextAction",
        "nextDate",
        "priority",
        "responsible",
        "assignedAt",
        showActions ? "actions" : null,
      ].filter(Boolean);

  return (
    <div className={containerClassName || "table-responsive"}>
      <Table hover className={`align-middle crm-postventa-v2-table ${className}`.trim()}>
        <thead>
          <tr>
            {includeProcess && <th>Proceso</th>}
            {compact ? (
              <>
                <th>Prioridad</th>
                <th>Comercio</th>
                <th>CUIT</th>
                <th>Estado</th>
                <th>Responsable</th>
                <th>Proxima accion</th>
                {showActions ? <th className="text-end">Acciones</th> : null}
              </>
            ) : (
              <>
                <th>Comercio</th>
                <th>CUIT</th>
                <th>Comercio / Terminal</th>
                <th>Origen</th>
                <th>Estado</th>
                <th>Intento</th>
                <th>Canal</th>
                <th>Proxima accion</th>
                <th>Fecha proxima</th>
                <th>Prioridad</th>
                <th>Responsable</th>
                <th>Asignado</th>
                {showActions ? <th className="text-end">Acciones</th> : null}
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {!rows.length ? (
            <tr>
              <td colSpan={columns.length} className="text-center text-muted py-4">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            rows.map((item) => (
              <tr key={`${item.procesoCodigo}-${item.id}`}>
                {includeProcess && <td>{item.procesoLabel || item.procesoCodigo || "-"}</td>}
                {compact ? (
                  <>
                    <td>{item.prioridad || "-"}</td>
                    <td>{item.comercio || "-"}</td>
                    <td>{item.cuit || "-"}</td>
                    <td>
                      <ProcessStatusBadge>{item.estadoLabel || item.estadoActual}</ProcessStatusBadge>
                    </td>
                    <td>
                      <div>{item.responsable || "Sin asignar"}</div>
                      {item.esSoloLectura ? (
                        <div className="small text-muted">{item.mensajeSoloLectura || "Solo lectura"}</div>
                      ) : null}
                    </td>
                    <td>
                      <div>{item.accionPermitida || "-"}</div>
                      <div className="small text-muted">{item.fechaProximaAccion || "-"}</div>
                    </td>
                    {showActions ? (
                      <td className="text-end">
                        <div className="d-flex flex-wrap justify-content-end gap-2">
                          {item.puedeTomar ? (
                            <Button size="sm" variant="outline-primary" onClick={() => onTake?.(item)} disabled={loading}>
                              Tomar
                            </Button>
                          ) : null}
                          {item.puedeAsignar ? (
                            <Button size="sm" variant="outline-secondary" onClick={() => onAssign?.(item)} disabled={loading}>
                              Asignar
                            </Button>
                          ) : null}
                          {item.puedeLiberar ? (
                            <Button size="sm" variant="outline-warning" onClick={() => onRelease?.(item)} disabled={loading}>
                              Liberar
                            </Button>
                          ) : null}
                          <Button
                            size="sm"
                            variant={item.esSoloLectura || item.puedeGestionar === false ? "outline-dark" : "success"}
                            onClick={() => onManage?.(item)}
                            disabled={loading}
                          >
                            {item.esSoloLectura || item.puedeGestionar === false ? "Ver detalle" : "Gestionar"}
                          </Button>
                        </div>
                      </td>
                    ) : null}
                  </>
                ) : (
                  <>
                    <td>{item.comercio || "-"}</td>
                    <td>{item.cuit || "-"}</td>
                    <td>
                      <div>{item.numeroComercio || "-"}</div>
                      <div className="small text-muted">{item.numeroTerminal || "-"}</div>
                    </td>
                    <td>{item.procesoOrigenLabel || item.procesoOrigenCodigo || "-"}</td>
                    <td>
                      <ProcessStatusBadge>{item.estadoLabel || item.estadoActual}</ProcessStatusBadge>
                    </td>
                    <td>{item.intentoActual || "-"}</td>
                    <td>{item.canalPermitido || "-"}</td>
                    <td>{item.accionPermitida || "-"}</td>
                    <td>{item.fechaProximaAccion || "-"}</td>
                    <td>{item.prioridad || "-"}</td>
                    <td>
                      <div>{item.responsable || "Sin asignar"}</div>
                      {item.esSoloLectura ? (
                        <div className="small text-muted">{item.mensajeSoloLectura || "Solo lectura"}</div>
                      ) : null}
                    </td>
                    <td>{item.responsableAsignadoEn || "-"}</td>
                    {showActions ? (
                      <td className="text-end">
                        <div className="d-flex flex-wrap justify-content-end gap-2">
                          {item.puedeTomar ? (
                            <Button size="sm" variant="outline-primary" onClick={() => onTake?.(item)} disabled={loading}>
                              Tomar
                            </Button>
                          ) : null}
                          {item.puedeAsignar ? (
                            <Button size="sm" variant="outline-secondary" onClick={() => onAssign?.(item)} disabled={loading}>
                              Asignar
                            </Button>
                          ) : null}
                          {item.puedeLiberar ? (
                            <Button size="sm" variant="outline-warning" onClick={() => onRelease?.(item)} disabled={loading}>
                              Liberar
                            </Button>
                          ) : null}
                          <Button
                            size="sm"
                            variant={item.esSoloLectura || item.puedeGestionar === false ? "outline-dark" : "success"}
                            onClick={() => onManage?.(item)}
                            disabled={loading}
                          >
                            {item.esSoloLectura || item.puedeGestionar === false ? "Ver detalle" : "Gestionar"}
                          </Button>
                        </div>
                      </td>
                    ) : null}
                  </>
                )}
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}
